import { render } from "./ShowOperativoContable.vue?vue&type=template&id=c0b7169e&scoped=true"
import script from "./ShowOperativoContable.vue?vue&type=script&lang=js"
export * from "./ShowOperativoContable.vue?vue&type=script&lang=js"

import "./ShowOperativoContable.vue?vue&type=style&index=0&id=c0b7169e&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b7169e"]])

export default __exports__